<template>
  <ul class="lg:flex lg:float-right list-none lg:ml-auto items-center space-y-3 lg:space-y-0 pi-menu">
    <nav-link :to="{ name: 'activities', query: { library: 'pivot' } }" className="px-4"
      >Activities</nav-link
    >

    <nav-dropdown :title="fullName || 'Welcome back!'" className="-mb-[10px]">
      <dropdown-action
        ><nav-link :to="{ name: 'edit_profile' }">
          Profile
        </nav-link></dropdown-action
      >
      <dropdown-action
        ><nav-link id="logout" :to="{ name: 'logout' }">
          Log out
        </nav-link></dropdown-action
      >
    </nav-dropdown>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import NavLink from 'src/shared/components/navigation/NavLink'
import NavDropdown from 'src/shared/components/navigation/NavDropdown'

export default {
  name: 'ContentDeveloperMenu',
  components: { NavLink, NavDropdown },
  computed: {
    ...mapGetters(['fullName'])
  }
}
</script>
